import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AppsSharedModule, BaseAssignmentsModule, BaseSharedModule } from 'base';
import { BaseCustomerSharedModule } from '../../shared/base-customer-shared.module';
import { BaseCustomerExternalEmployeeFiltersComponent } from './_components/filters/base-customer-external-employee-filters.component';
import { BaseCustomerExternalEmployeeSearchExportComponent } from './_components/row-headline/base-customer-external-employee-search-export.component';
import { BaseCustomerExternalEmployeeListHeadlineComponent } from './_components/list-headline/base-customer-external-employee-list-headline.component';
import { BaseCustomerExternalEmployeeListItemComponent } from './_components/list-item/base-customer-external-employee-list-item.component';
import { BaseCustomerExternalEmployeeShortInfoComponent } from './_components/short-info/base-customer-external-employee-short-info.component';
import { BaseCustomerExternalEmployeeListComponent } from './_components/list/base-customer-external-employee-list.component';
import { BaseCustomerEmployeeInfoModalComponent } from './_components/employee-info-modal/base-customer-employee-info-modal.component';
import { ExternalEmployeeService } from './external-employee.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    BaseSharedModule,
    AppsSharedModule,
    BaseCustomerSharedModule,
    NgbTooltipModule,
    BaseAssignmentsModule,
  ],
  declarations: [
    BaseCustomerExternalEmployeeListComponent,
    BaseCustomerExternalEmployeeFiltersComponent,
    BaseCustomerExternalEmployeeSearchExportComponent,
    BaseCustomerExternalEmployeeListHeadlineComponent,
    BaseCustomerExternalEmployeeListItemComponent,
    BaseCustomerExternalEmployeeShortInfoComponent,
    BaseCustomerEmployeeInfoModalComponent,
  ],
  exports: [
    BaseCustomerExternalEmployeeListComponent,
    BaseCustomerExternalEmployeeFiltersComponent,
    BaseCustomerExternalEmployeeSearchExportComponent,
    BaseCustomerExternalEmployeeListHeadlineComponent,
    BaseCustomerExternalEmployeeListItemComponent,
    BaseCustomerExternalEmployeeShortInfoComponent,
    BaseCustomerEmployeeInfoModalComponent,
  ],
  providers: [ExternalEmployeeService],
})
export class BaseCustomerExternalEmployeeModule {}
